import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ProfileService {
   api = `${environment.restAPIUrl}/api`
  constructor(private http:HttpClient) {

   }

   getMemberProfile(){
     return this.http.get(`${this.api}/members/getMemberDetails`);
   }
   
   memberDetails(){
    return this.http.get(`${this.api}/members/getMemberByDetails`);
  }
   editMemberProfile(obj){
    return this.http.post(`${this.api}/members/updateProfile`,obj);
   };

   getDoctorProfile(){
    return this.http.get(`${this.api}/doctor/editProfile`);
   };
   editDoctorProfile(obj){
    return this.http.post(`${this.api}/doctor/editProfile`,obj);
   }
}
